<template>
  <table id="tblReceipts" class="table table-hover table-center mb-0 datatable"
         v-bind:class="windowWidth < 768 ? 'cards' : ''">
    <thead style="background-color: ghostwhite">
    <tr class="text-center">
      <th scope="col" class="text-left">Number</th>
      <th scope="col" class="text-left">Date</th>
      <th scope="col" class="text-left">Method</th>
      <th scope="col" class="text-left" hidden>Type</th>
      <th scope="col" class="text-left" hidden>Tendered</th>
      <th scope="col" class="text-left" hidden>Base Amount</th>
      <th scope="col" class="text-left" hidden>Transaction Amount</th>
      <th scope="col" class="text-left">Amount</th>
      <th scope="col" class="text-left" hidden>Remaining</th>
      <th scope="col" class="text-left" hidden>Type</th>
      <th scope="col" class="text-left" hidden>Created At</th>
      <th scope="col" class="text-left" hidden>Created By</th>
      <th scope="col" class="text-left">Status</th>
      <th scope="col" class="text-right"></th>
    </tr>
    </thead>
    <LoadingSkeleton v-if="isLoading" :rows="10" :columns="6"/>
    <tbody v-if="receipts && receipts.length && !isLoading">
    <tr class="text-center clickable-row" @click="viewReceipt(receipt.id)" v-for="receipt in receipts" :key="receipt.id" style="margin-bottom: 20px !important; cursor: pointer;">
      <td col="Number: " class="text-left">{{ receipt.number ? receipt.number : '-' }}</td>
      <td col="Date: " class="text-left">{{ receipt.date ? utcDateToLocal(receipt.date) : '-' }}</td>
      <td col="Method: " class="text-left">
        {{ receipt.paymentMethod ? enumToHumanReadable(receipt.paymentMethod.description) : '-' }}
      </td>
      <td col="Type: " class="text-left" hidden>
        {{ receipt.paymentType ? enumToHumanReadable(receipt.paymentType) : '-' }}
      </td>
      <td col="Amount Tendered: " class="text-left" hidden>{{
          receipt.amountTenderedCurrency ? new Intl.NumberFormat('en-ZA', {
            style: 'currency',
            currency: receipt.amountTenderedCurrency === 'RTGS' ? 'ZWL' : receipt.amountTenderedCurrency
          }).format(receipt.amountTendered / 100) : '-'
        }}
      </td>
      <td col="Base Amount: " class="text-left" hidden>{{
          receipt.currency ? new Intl.NumberFormat('en-ZA', {
            style: 'currency',
            currency: receipt.currency
          }).format(receipt.amount / 100) : '-'
        }}
      </td>
      <td col="Tendered: " hidden class="text-left">{{
          receipt.transactionCurrency ? new Intl.NumberFormat('en-ZA', {
            style: 'currency',
            currency: receipt.transactionCurrency
          }).format(receipt.amountPaid / 100) : '-'
        }}
      </td>
      <td col="Amount: " class="text-left">
          <span v-if="receipt.paymentType === 'REFUND'" style="color: orangered">
            {{ formatDisplayAmount(receipt) }}
          </span>
        <span v-else-if="receipt.paymentType === 'PAYMENT'" style="color: green">
            {{ formatDisplayAmount(receipt) }}
          </span>
        <span v-else>
            {{ formatDisplayAmount(receipt) }}
          </span>
      </td>
      <td col="Remaining: " class="text-left" hidden>{{
          receipt.transactionCurrency ? new Intl.NumberFormat('en-ZA', {
            style: 'currency',
            currency: receipt.transactionCurrency
          }).format(receipt.amountRemaining / 100) : '-'
        }}
      </td>
      <td hidden col="Created At: " class="text-left">
        {{ receipt.paymentType ? enumToHumanReadable(receipt.paymentType) : '-' }}
      </td>
      <td col="Created At: " class="text-left" hidden>
        {{ receipt.dateCreated ? utcDateToLocal(receipt.dateCreated) : '-' }}
      </td>
      <td col="Created By: " class="text-left wrap-text-100" hidden>{{
          receipt.createdBy ? receipt.createdBy : '-'
        }}
      </td>
      <td col="Status: " class="text-left">
        <label v-if="receipt.status === 'ACCEPTED'" class="badge bg-info-light" style="color: white">APPROVED</label>
        <label v-else-if="receipt.status === 'POSTPONED'" class="badge bg-warning-light"
               style="color: white">POSTPONED</label>
        <label v-else-if="receipt.status === 'DONE'" class="badge badge-success" style="color: white">DONE</label>
        <label v-else-if="receipt.status === 'CANCELLED'" class="badge badge-secondary"
               style="color: white">CANCELLED</label>
        <label v-else-if="receipt.status === 'REFUNDED'" class="badge badge-warning"
               style="color: white">REFUNDED</label>
        <label v-else class="badge bg-info-light" style="color: white"> {{ receipt.status }} </label>
      </td>
      <td class="text-right">
        <i class="fas fa-chevron-right text-muted"></i>
      </td>
    </tr>
    </tbody>
  </table>

</template>

<script>

import {enumToHumanReadable, utcDateToLocal} from "../../utils/utils";
import {getConfig} from "../../utils/config";
import LoadingSkeleton from "../shared/LoadingSkeleton";
import {displayAmount, formatDisplayAmount} from "../../utils/money";

export default {
  name: 'receipt-list-table',
  components: {
    LoadingSkeleton
  },
  data() {
    return {
      isMobileView: false,
      isTabletView: false,
      isDesktopView: false,
      displayDisabledButtons: !getConfig().hideIfNoPermission
    }
  },
  props: {
    receipts: Array,
    permissions: Object,
    isLoading: Boolean,
  },
  methods: {
    utcDateToLocal: utcDateToLocal,
    enumToHumanReadable: enumToHumanReadable,
    displayAmount: displayAmount,
    formatDisplayAmount(receipt) {
      let amount = receipt.amountPaid / 100;
      return formatDisplayAmount(receipt.transactionCurrency, amount);
    },
    viewReceipt(id) {
      this.$router.push(`/receipts/${id}`)
    },
  },
  computed: {
    windowWidth() {
      return this.$store.state.app.windowWidth;
    },
    // hasEditAndDeleteReceiptPermissions(){
    //   return this.permissions.includes('RECEIPT_UPDATE') && this.permissions.includes('RECEIPT_DELETE') && this.permissions.includes('RECEIPT_READ')
    // },
    hasViewReceiptPermission() {
      return this.permissions['RECEIPT_READ']
    },
    showButton() {
      if (this.hasViewReceiptPermission) {
        return true
      } else {
        return this.displayDisabledButtons
      }
    },
    isDisabled() {
      return !this.hasViewReceiptPermission
    },
    buttonTooltip() {
      return this.isDisabled ? 'You do not have access to this feature' : ''
    },
    basedOnWindowWidth() {
      if (this.windowWidth > 768) {
        return true;
      }
      return false;
    }
  },
  watch: {
    windowWidth: function () {
      if (this.windowWidth < 768) {
        this.isMobileView = true
      }
      if (this.windowWidth >= 768 && this.windowWidth <= 1200) {
        this.isTabletView = true
      }
      if (this.windowWidth > 1200) {
        this.isDesktopView = true
      }
    }
  }
}
</script>

<style>
button:disabled {
  cursor: not-allowed
}

.clickable-row {
  cursor: pointer;
}

.clickable-row:hover {
  background-color: #f8f9fa;
}

.cards thead {
  display: none;
}

.cards tr {
  display: flex;
  flex-direction: column;

  margin-bottom: 5px !important;
  /*border: 1px solid navajowhite !important;*/
  border: 1px solid rgba(0, 0, 0, 0.1) !important;;
}

.cards tr > th {
  display: none;
}

.hide-on-mobile {
  display: none;
}

.cards tr > td::before {
  content: attr(col) '';
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/components/receipts/ReceiptListTable.vue